<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { NSkeleton } from "naive-ui";
import BackgroundImage from "../assets/images/login-background.jpeg";
import { fetchPortalProperganda } from "../services/cms";

const { data: propergandaData, isLoading } = useQuery({
    queryKey: ["portal-propaganda"],
    queryFn: fetchPortalProperganda,
});
</script>

<template>
    <div class="w-full h-full bg-white p-8">
        <div
            class="h-full bg-cover bg-center rounded-xl flex justify-center items-center"
            :style="{ backgroundImage: `url(${BackgroundImage})` }"
        >
            <div
                class="w-[360px] h-[480px] p-2 bg-white flex flex-col justify-between items-center gap-6 rounded-xl shadow-lg"
            >
                <div v-if="isLoading" class="w-full h-72 rounded-2xl overflow-hidden">
                    <n-skeleton height="100%" width="100%" />
                </div>
                <div v-else-if="propergandaData" class="w-full h-72 rounded-2xl overflow-hidden">
                    <img
                        :src="propergandaData"
                        alt="Portal propaganda"
                        class="w-full h-full object-cover"
                    />
                </div>
                <div v-else class="w-full h-72 rounded-2xl overflow-hidden">
                    <img
                        :src="BackgroundImage"
                        alt="Background"
                        class="w-full h-full object-cover"
                    />
                </div>
                <div class="mb-8 flex flex-col gap-3">
                    <h1 class="text-3xl font-bold text-dark-mode-gray-4 text-center">
                        Welcome to your<br />Proper Portal
                    </h1>
                    <p class="text-gray-600 text-center">Your destination for all things Proper</p>
                </div>
            </div>
        </div>
    </div>
</template>
